// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { MenuPage, MenuPageT, verifyMenuPage } from "./menu-page";

/**
 * Top-level role menu containing permission pages.
 */
export class RoleMenu implements flatbuffers.IUnpackableObject<RoleMenuT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): RoleMenu {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsRoleMenu(bb: flatbuffers.ByteBuffer, obj?: RoleMenu): RoleMenu {
    return (obj || new RoleMenu()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsRoleMenu(bb: flatbuffers.ByteBuffer, obj?: RoleMenu): RoleMenu {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new RoleMenu()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  offline(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  pages(index: number, obj?: MenuPage): MenuPage | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new MenuPage()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  pagesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  description(): string | null;
  description(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  description(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  locked(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startRoleMenu(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nameOffset, 0);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(1, +active, +true);
  }

  static addOffline(builder: flatbuffers.Builder, offline: boolean) {
    builder.addFieldInt8(2, +offline, +true);
  }

  static addPages(builder: flatbuffers.Builder, pagesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, pagesOffset, 0);
  }

  static createPagesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startPagesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addDescription(builder: flatbuffers.Builder, descriptionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, descriptionOffset, 0);
  }

  static addLocked(builder: flatbuffers.Builder, locked: boolean) {
    builder.addFieldInt8(5, +locked, +false);
  }

  static endRoleMenu(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createRoleMenu(
    builder: flatbuffers.Builder,
    nameOffset: flatbuffers.Offset,
    active: boolean,
    offline: boolean,
    pagesOffset: flatbuffers.Offset,
    descriptionOffset: flatbuffers.Offset,
    locked: boolean,
  ): flatbuffers.Offset {
    RoleMenu.startRoleMenu(builder);
    RoleMenu.addName(builder, nameOffset);
    RoleMenu.addActive(builder, active);
    RoleMenu.addOffline(builder, offline);
    RoleMenu.addPages(builder, pagesOffset);
    RoleMenu.addDescription(builder, descriptionOffset);
    RoleMenu.addLocked(builder, locked);
    return RoleMenu.endRoleMenu(builder);
  }

  unpack(): RoleMenuT {
    return new RoleMenuT(
      this.name(),
      this.active(),
      this.offline(),
      this.bb!.createObjList<MenuPage, MenuPageT>(this.pages.bind(this), this.pagesLength()),
      this.description(),
      this.locked(),
    );
  }

  unpackTo(_o: RoleMenuT): void {
    _o.name = this.name();
    _o.active = this.active();
    _o.offline = this.offline();
    _o.pages = this.bb!.createObjList<MenuPage, MenuPageT>(
      this.pages.bind(this),
      this.pagesLength(),
    );
    _o.description = this.description();
    _o.locked = this.locked();
  }

  unpackFields(...fields: string[]): RoleMenuT {
    const t = new RoleMenuT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("offline")) {
      t.offline = this.offline();
    }
    if (fieldSet.has("pages")) {
      t.pages = this.bb!.createObjList<MenuPage, MenuPageT>(
        this.pages.bind(this),
        this.pagesLength(),
      );
    }
    if (fieldSet.has("description")) {
      t.description = this.description();
    }
    if (fieldSet.has("locked")) {
      t.locked = this.locked();
    }
    return t;
  }
}

export class RoleMenuT implements flatbuffers.IGeneratedObject {
  constructor(
    public name: string | Uint8Array | null = null,
    public active: boolean = true,
    public offline: boolean = true,
    public pages: MenuPageT[] = [],
    public description: string | Uint8Array | null = null,
    public locked: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const pages = RoleMenu.createPagesVector(builder, builder.createObjectOffsetList(this.pages));
    const description = this.description !== null ? builder.createString(this.description!) : 0;

    return RoleMenu.createRoleMenu(
      builder,
      name,
      this.active,
      this.offline,
      pages,
      description,
      this.locked,
    );
  }

  clone(): RoleMenuT {
    const obj = new RoleMenuT();
    obj.name = this.name;
    obj.active = this.active;
    obj.offline = this.offline;
    obj.pages = this.pages.map((e) => e.clone());
    obj.description = this.description;
    obj.locked = this.locked;
    return obj;
  }

  equals(other: RoleMenuT): boolean {
    if (this.name !== other.name) return false;
    if (this.active !== other.active) return false;
    if (this.offline !== other.offline) return false;
    if (this.pages.length !== other.pages.length) return false;
    for (let i = 0; i < this.pages.length; i++) {
      const a = this.pages[i];
      const b = other.pages[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.description !== other.description) return false;
    if (this.locked !== other.locked) return false;
    return true;
  }
}

export function verifyRoleMenu(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyMenuPage);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 14, 1);
  } finally {
    verifier.popDepth();
  }
}
